import { Layout } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const StyledHeader = styled(Layout.Header)`
  position: relative;
  height: fit-content;
  background-color: ${APP_SHELL_THEME.pageBg} !important;
  border-bottom: 1px solid ${APP_SHELL_THEME.panelBorder};
  line-height: 0;
  padding: 24px 24px 20px 24px;
`;
